import { render, staticRenderFns } from "./MediaItemDialog.vue?vue&type=template&id=d00c59fc"
import script from "./MediaItemDialog.vue?vue&type=script&lang=ts"
export * from "./MediaItemDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports